// extracted by mini-css-extract-plugin
module.exports = {"header":"farmCard_header__1wIz8","right":"farmCard_right__1X10B","cell":"farmCard_cell__1MiF4"};